import science from "./img/science0.jpg";
import science1 from "./img/science1.jpg";
import science2 from "./img/science2.jpg";
import science3 from "./img/science3.jpg";
import science4 from "./img/science4.jpg";
import science5 from "./img/science5.jpg";

const images = [science, science1, science2, science3, science4, science5];

export default images;



// WEBPACK FOOTER //
// ./src/data/images.js